// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6ca7493f","239":"864161da","453":"8b4e58d7","667":"cd5077c8"}[chunkId] + ".chunk.js";
};